<template>
    <div v-if="!list.loading" class="side-menu">
        <b class="heading">
            Task manager

            <i v-if="space_permission('FLOW_CREATE')"
               @click="show_create_modal = true"
               class="add-topic icon fas fa-plus-square is-pulled-right"></i>

            <span v-if="loading" class="is-pulled-right loader"></span>
        </b>

        <router-link :to="{name: 'milestones', params: {space: space.id}}" class="menu-item">
            <i class="icon fas fa-map-signs"></i> Milestones
        </router-link>

        <flows-list-item
            v-for="flow in list.data.results"
            :space="space"
            :flow="flow"
            :key="flow.id"/>

        <flow-create-modal
            :space="space"
            :visible="show_create_modal"
            @close="show_create_modal = false"/>
    </div>

    <sidebar-skeleton v-else :items="2"/>
</template>

<script>
import { mapState } from 'vuex';
import SidebarSkeleton from '../skeletons/SidebarSkeleton.vue';
import FlowCreateModal from './FlowCreateModal.vue';
import FlowsListItem from './FlowsListItem.vue';

export default {
    name: 'FlowsList',
    components: { FlowCreateModal, FlowsListItem, SidebarSkeleton },
    props: ['space'],
    data() {
        return {
            show_create_modal: false,
        };
    },
    computed: {
        ...mapState('flows', ['list', 'create', 'remove']),
        loading() {
            return this.create.loading || this.remove.loading;
        },
    },
    mounted() {
        this.$store.dispatch('flows/list', { space_id: this.space.id });
    },
};
</script>
